/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".notification-toast-wrapper[_ngcontent-%COMP%]{position:fixed;z-index:999999;bottom:12px;right:12px}"];
export { styles as styles };
